module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/feature_5-a5cad3d088be671267002059463603a3.png";